import React from "react"; 
import { StoryblokComponent } from "gatsby-source-storyblok";
import ParentMenuItem from '../../components/parent_menu_item/parent_menu_item'
import { ProcessLink } from "../../global/helpers"

const Footer = (data) => {     
 
  //Icons
  const socialAccounts = data.data.social_accounts.map((blok, index)  => { 
    return (
      <li key={"social_account_" + index}>
        <StoryblokComponent blok={blok} key={blok._uid} />
      </li>
    )
  })

  //Legal Links
  const footerLegalLinks = data.data.footer_legal_links.map((footer_legal_links, index) => { 
     
    let FooterLink = ProcessLink(footer_legal_links.link);  
    FooterLink.cssClass = (footer_legal_links.css_class) ? FooterLink.cssClass + " " + footer_legal_links.css_class : FooterLink.cssClass; 

    return (
      <React.Fragment key={"footer_legal_links" + index}>
        <a href={FooterLink.url} target={FooterLink.target} rel={FooterLink.rel} title={FooterLink.title} className={"legal-link " + FooterLink.cssClass} >{footer_legal_links.title}</a>
        <span className="link_divider">|</span>
      </React.Fragment>
    )
  }); 

  const contact_link = ProcessLink(data.data.contact_link);

  //Menu Items
  const menuItems = data.data.footer_menu.map(footer_menu => ( <ParentMenuItem key={footer_menu._uid} data={footer_menu} /> ));

  return (
    <footer id="z-footer"> 
      <div className="inner">

        <div id="z-footer-logo">
          <span aria-label="Icon" className="svg-icon">
            <svg width="28" height="64" viewBox="0 0 28 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.61026 44.2766L8.43743 64L18.0302 44.2766L27.6229 24.5532H17.7326L18.0127 19.7234L19.1855 0L9.59275 19.7234L0 39.4292H9.89033L9.61026 44.2766Z" fill="currentColor"></path>
            </svg>
          </span>
        </div>  

        <span id="z-footer-border"></span>
    
        <nav id="z-footer-menu" className="menu-container"> 
          <ul className="menu">
            <li key="parent_contact_menu" className="menu-item menu-item-has-children current-menu-parent">
              <div className="contact-title menu-item-title">
                <a href={contact_link.url} className={contact_link.cssClass} target={contact_link.target} >{data.data.contact_title}</a>
              </div> 

              <ul className="sub-menu"> 
                <div className="submenu_inner">
                  <li key="email_address" className="menu-item">
                    <div className="page-info">
                      <a href={"mailto:" + data.data.email_address}><span className="title">{data.data.email_address}</span></a>
                    </div>{/*/page-info */}  
                  </li>
                  <li key="phone_number" className="menu-item">
                    <div className="page-info">
                      <a href={"tel:" + data.data.phone_number.replace(/[-\s.]/g, "")}><span className="title">{data.data.phone_number}</span></a>
                    </div>{/*/page-info */}  
                  </li>
                </div>{/*/submenu_inner */}
              </ul>{/*/sub-menu */}

              <ul className="social_icons">
                {socialAccounts}
              </ul> 
            </li>

            {menuItems}
            
          </ul>
        </nav>    

        <ul className="social_icons mobile">
          {socialAccounts}
        </ul>

        <div id="z-footer-copyright">
          <div className="legal-links">{footerLegalLinks}</div> 
          <span>{data.data.copyright_text.replace('{{Year}}', new Date().getFullYear())}</span>
        </div>{/* /footer-copyright */} 

      </div>{/* /inner */}   
  </footer> 
  )
 
};
 
export default Footer;